<nav class="navbar navbar-expand-lg bg-body-tertiary" aria-label="main navigation"
    data-bs-theme="dark">
    <div class="container-fluid">
        <div class="navbar-brand" i18n>
                Functioneringsgesprek voor AI
        </div>

        <button class="navbar-toggler" type="button"
            aria-controls="navigation-links"
            [attr.aria-expanded]="burgerActive"
            aria-label="toggle navigation"
            (click)="toggleBurger()"
            i18n-aria-label>
            <span class="navbar-toggler-icon"></span>
        </button>

        <div id="navigation-links" class="navbar-collapse" [ngbCollapse]="!burgerActive">
            <ul class="navbar-nav">
                <li class="nav-item">
                    <a [routerLink]="['/home']" routerLinkActive="active" class="nav-link" i18n>
                        Startpagina
                    </a>
                </li>
                <li class="nav-item">
                    <a [routerLink]="['/dashboard']" routerLinkActive="active" class="nav-link" i18n>
                        Dashboard
                    </a>
                </li>
            </ul>

            <ul class="navbar-nav ms-auto">
                <li class="nav-item">
                    <fgai-dark-mode-toggle role="listitem" class="nav-item" />
                </li>
                @if (languages) {
                    <li class="nav-item" ngbDropdown>
                        <button class="nav-link" ngbDropdownToggle
                            id="language-dropdown-toggle"
                            aria-label="language"
                            i18n-aria-label>
                            @if (loading) {
                                <span class="spinner-border spinner-border-sm"></span>
                                <span class="visually-hidden" i18n>Loading languages...</span>
                            } @else {
                                <fa-icon [icon]="faGlobe" aria-hidden="true" />
                            }
                        </button>
                        <div ngbDropdownMenu aria-labelledby="language-dropdown-toggle"
                            class="dropdown-menu dropdown-menu-end">
                            <button *ngFor="let language of languages"
                                ngbDropdownItem
                                class="navbar-item"
                                [class.active]="language.code == currentLanguage"
                                [attr.aria-pressed]="language.code == currentLanguage"
                                (click)="setLanguage(language.code)">
                            {{language.name}}
                        </button>
                        </div>
                    </li>
                }

            <fgai-user-menu />

            </ul>
        </div>
    </div>
</nav>
